import CARD_HOLDER_ACTIONS from './creator'

const init = {
  waitProgress: false,
  isError: false,
  data: {
    list: [],
    pagination: {
      page: 1,
      itemPerPage: 10,
      count: 0,
      totalCount: 0,
    },
  },
}

export const CardHolderTableDataList = (state = init, { type, payload }) => {
  switch (type) {
    case CARD_HOLDER_ACTIONS.PENDING:
    case CARD_HOLDER_ACTIONS.SUCCESS:
      return { ...state, ...payload }
    case CARD_HOLDER_ACTIONS.FAILURE:
      return { ...state, ...payload, data: init.data }
    case CARD_HOLDER_ACTIONS.UPDATE_LIST:
      // payload = {id: , status: Approved|Rejected}
      if (!payload.id) {
        return
      }
      const findIndex = state.data.list.findIndex((item) => {
        return item.id === payload.id
      })
      if (findIndex !== -1) {
        state.data.list[findIndex] = { ...state.data.list[findIndex], ...payload.data }
      }

      return { ...state }
    default:
      return state
  }
}
